var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "avue-top" }, [
    _c("div", { staticClass: "top-bar__left" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("../../../../public/img/logo.png"), alt: "" },
      }),
      _c("span", [_vm._v("智能家居云平台")]),
      _c("div", { staticClass: "home", on: { click: _vm.jumpHome } }, [
        _c("i", {
          staticClass: "iconfont icon-shouye",
          staticStyle: { "font-size": "19px" },
        }),
        _c("span", { staticClass: "title" }, [_vm._v("首页")]),
      ]),
    ]),
    _c("div", { staticClass: "top-bar__title" }, [
      _vm.showMenu
        ? _c(
            "div",
            { staticClass: "top-bar__item top-bar__item--show" },
            [_c("top-menu")],
            1
          )
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "top-bar__right" },
      [
        _c(
          "el-dropdown",
          [
            _c("span", { staticClass: "el-dropdown-link" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.userInfo.username) + "\n        "
              ),
              _c("i", { staticClass: "el-icon-arrow-down el-icon--right" }),
            ]),
            _c(
              "el-dropdown-menu",
              {
                staticClass: "user-info",
                attrs: { slot: "dropdown" },
                slot: "dropdown",
              },
              [
                _c(
                  "el-dropdown-item",
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _vm.jumpInfo.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-gerenzhongxin" }),
                    _vm._v("\n          个人信息\n          "),
                  ]
                ),
                _c(
                  "el-dropdown-item",
                  {
                    nativeOn: {
                      click: function ($event) {
                        return _vm.logout.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "iconfont icon-tuichudenglu" }),
                    _vm._v("\n          退出系统\n        "),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("top-setting", { ref: "seting" }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }